define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/WaWfAsset", "../../utils/MathUtil", "../domain", "../entity/Facility", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, WaWfAsset_1, MathUtil_1, domain_1, Facility_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaWaterFacility = void 0;
    class WaWaterFacility extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LocationRef", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LocationRefError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWfAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedWaWfAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaWfAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LinkedFacility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLinkedFacilityLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "Assets", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaWaterFacility.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.WaWfAsset = [];
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.WaWfAsset = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.FId = (0, EntityUtil_1.toInt)(entity.FId);
            a.FacilityId = b.FacilityId;
            a.FacilityName = b.FacilityName;
            a.FacilityType = (0, EntityUtil_1.toInt)(entity.FacilityType);
            a.OwnerType = (0, EntityUtil_1.toInt)(entity.OwnerType);
            a.LocationRef = b.LocationRef;
            a.WaWfAsset = this.mergeArray(a.WaWfAsset, b.WaWfAsset, WaWfAsset_1.WaWfAsset);
            a.SelectedWaWfAsset = a.SelectedWaWfAsset && a.WaWfAsset.find(x => x.Id == a.SelectedWaWfAsset.Id) ? a.SelectedWaWfAsset : null;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.buildAssetViewModel(this.LinkedFacility);
        }
        onReady() {
            this.addChangeEventAction("FId", this.onLinkedFacilityChange.bind(this));
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaWaterFacility.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
                this.validateReqNumber(validationState, "FId", "Facility Id");
                this.validateReqNumber(validationState, "FacilityType", "Facility Type");
                this.validateReqNumber(validationState, "OwnerType", "Owner Type");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.WaWfAsset) {
                for (let x of this.WaWfAsset) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            this.syncModelWithAssetViewModelChanges();
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                FId: this.FId,
                FacilityId: this.FacilityId,
                FacilityName: this.FacilityName,
                FacilityType: this.FacilityType,
                OwnerType: this.OwnerType,
                LocationRef: this.LocationRef,
                WaWfAsset: this.WaWfAsset.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(wa, ownerType, geometry) {
            return new Promise((resolve, reject) => {
                let wf = new WaWaterFacility(null, wa);
                wf.FId = -1;
                wf.FacilityId = "L" + (0, MathUtil_1.generateRandom)(10000, 99999).toString();
                wf.FacilityName = "";
                wf.FacilityType = domain_1.FacilityTypeDomain.ArtesianWater;
                wf.OwnerType = ownerType;
                wf.LocationRef = "";
                wf.Shape = geometry;
                wa.WaWaterFacility.push(wf);
                resolve(wf);
            });
        }
        lazyLoadLinkedFacility() {
            return new Promise((resolve, reject) => {
                if (this.Wa.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    return resolve(undefined);
                }
                if (!this.IsLinkedFacilityLoaded) {
                    this.IsLinkedFacilityLoaded = true;
                    if (this.FId != -1) {
                        (0, EventManager_1.notify)("Loading Facility");
                        services_1.SrmsServiceManager.Instance.Facility.readFacility(this.FId).then(f => {
                            this.LinkedFacility = new Facility_1.Facility(f);
                            this.buildAssetViewModel(this.LinkedFacility);
                            resolve(this.LinkedFacility);
                        });
                    }
                    else {
                        resolve(this.LinkedFacility);
                    }
                }
                else {
                    resolve(this.LinkedFacility);
                }
            });
        }
        buildAssetViewModel(facility) {
            if (facility) {
                this.Assets = facility.FAsset.filter((a) => a.Status != domain_1.FAssetStatusDomain.NotPresent && a.Status != domain_1.FAssetStatusDomain.Transferred).map((a) => {
                    let match = this.WaWfAsset.find((wfa) => wfa.FAssetId == a.Id);
                    let wfa = null;
                    if (match) {
                        wfa = match;
                    }
                    else {
                        wfa = new WaWfAsset_1.WaWfAsset(null, this);
                        wfa.FAssetId = a.Id;
                    }
                    wfa.Asset = a;
                    return wfa;
                });
            }
        }
        syncModelWithAssetViewModelChanges() {
            if (this.Assets) {
                for (let a of this.Assets) {
                    a.MaintWork = !!a.MaintWork ? a.MaintWork.trim() : "";
                    a.MaintCondition = !!a.MaintCondition ? a.MaintCondition.trim() : "";
                    a.MaintMaterial = !!a.MaintMaterial ? a.MaintMaterial.trim() : "";
                    let hasData = a.MaintWork.length > 0 || a.MaintCondition.length > 0 || a.MaintMaterial.length > 0;
                    let match = this.WaWfAsset.find(wfa => wfa.Id == a.Id);
                    if (match) {
                        if (hasData) {
                            match.MaintWork = a.MaintWork;
                            match.MaintCondition = a.MaintCondition;
                            match.MaintMaterial = a.MaintMaterial;
                        }
                        else {
                            match.markForDeletion();
                            let x = new WaWfAsset_1.WaWfAsset(null, this);
                            x.FAssetId = a.FAssetId;
                            x.Asset = a.Asset;
                            a = x;
                        }
                    }
                    else {
                        if (hasData) {
                            this.WaWfAsset.push(a);
                        }
                    }
                }
            }
        }
        onLinkedFacilityChange(change) {
            const { oldVal, newVal } = (0, EntityUtil_1.parseChangeEvent)(change);
            if (oldVal !== newVal) {
                console.log(oldVal, newVal);
                this.IsLinkedFacilityLoaded = false;
                this.lazyLoadLinkedFacility();
            }
        }
    }
    exports.WaWaterFacility = WaWaterFacility;
    Object.defineProperty(WaWaterFacility, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaWaterFacility"
    });
    Object.defineProperty(WaWaterFacility, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WA Facility"
    });
    Object.defineProperty(WaWaterFacility, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "FId", "FacilityId", "FacilityName", "FacilityType", "OwnerType", "LocationRef", "Shape"]
    });
    Object.defineProperty(WaWaterFacility, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "FIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "FacilityIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(WaWaterFacility, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaWaterFacility, "FacilityNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 70
    });
    Object.defineProperty(WaWaterFacility, "FacilityNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaWaterFacility, "FacilityTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "FacilityTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "OwnerTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Is this a private water facility?"
    });
    Object.defineProperty(WaWaterFacility, "OwnerTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "OwnerTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaWaterFacility, "LocationRefLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaWaterFacility, "LocationRefTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Describe the physical location of the water facility"
    });
    Object.defineProperty(WaWaterFacility, "LocationRefReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "FacilityTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "OwnerType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "OwnerTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "LocationRef", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "LocationRefError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "WaWfAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "SelectedWaWfAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "WaWfAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWaterFacility.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWaterFacility.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWaterFacility.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "LinkedFacility", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "IsLinkedFacilityLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaWaterFacility.prototype, "Assets", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaWaterFacility.prototype, "lazyLoadLinkedFacility", null);
});
